import { DownloadOutlined } from "@ant-design/icons";
import { Button, Divider, Table } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { VendorTypeColumn, CookieNameColumn, InformationStorageColumn, LastAppearedScanColumn, PrevalenceBenchMarkColumn, PrevalenceColumn, TechnologyCategorisationColumn, VendorDetailsColumn, VendorNameColumn, VendorReferenceColumn, VendorStatusColumn } from "../../shared/DiagnoseColumns";

import {
    getVendorManagementStatusesList,
    getVendorsNotOnVendorFilter,
    getVendorsNotOnVendorList,
    vendorsNotOnVendorExport
} from "../../../../actions/diagnose_dashboard_actions";
import useTableDisplayConfig from "../../shared/useTableDispayConfig";
import useSearchParams from '../../shared/useSearchParams';
import { isFiltersProvided, mapSelectedFilters } from '../helpers';

const DetailedBreakdown = ({ userDetails, getVendorsNotOnVendorList, vendorsNotOnVendorList, vendorsNotOnVendorListPending, vendorsNotOnVendorFilter, getVendorsNotOnVendorFilter, selectedFilters, vendorsNotOnVendorExport, vendorsNotOnVendorExportPending, getVendorManagementStatusesList, vendorManagementStatuses, vendorManagementStatusesPending, vendorManagementActivities }) => {
    const { limit, page, orderBy, handleLimit, handlePageChange, handleOrder } = useTableDisplayConfig(10, 1, 'name_asc');
    const [technologies, setTechnologies] = useState('');
    const [referenceVendors, setReferenceVendors] = useState('');
    const [cookies, setCookies] = useState('');
    const [vendorNames, setVendorNames] = useState('');
    const [vendorTypes, setVendorTypes] = useState('');
    const [useFingerprint, setUseFingerprint] = useState(null);
    const [useLocalStorage, setUseLocalStorage] = useState(null);
    const [useSessionCookies, setUseSessionCookies] = useState(null);
    const [usePersistentCookies, setUsePersistentCookies] = useState(null);
    const [benchRisk, setBenchRisk] = useState([null, null]);
    const [prevalenceRisk, setPrevalenceRisk] = useState([null, null]);
    const searchParams = useSearchParams();
    const filters = useMemo(() => mapSelectedFilters(selectedFilters), [selectedFilters]);

    const [metricDataWithStatuses, setMetricDataWithStatuses] = useState([]);

    const getVendorsNotOnVendorListData = () => {
        getVendorsNotOnVendorList({
            ...filters,
            page,
            limit,
            orderBy,
            technologies,
            useFingerprint,
            useLocalStorage,
            useSessionCookies,
            usePersistentCookies,
            benchRisk,
            prevalenceRisk,
            cookies,
            vendorNames,
            vendorTypes,
            referenceVendors,
            vendorId: searchParams?.vendor,
        });
    };

    const getVendorManagementStatusesListData = (vendors) => {
        getVendorManagementStatusesList({
            metric: "Non disclosed vendors observed",
            vendors,
            websites: selectedFilters?.websites,
        });
    };

    const getVendorsNotOnVendorFiltersData = () => {
        getVendorsNotOnVendorFilter(filters);
    };

    useEffect(() => {
        if (isFiltersProvided(filters)) {
            getVendorsNotOnVendorListData();
        }
    }, [
        page,
        orderBy,
        technologies,
        cookies,
        useFingerprint,
        useLocalStorage,
        useSessionCookies,
        usePersistentCookies,
        benchRisk,
        prevalenceRisk,
        vendorNames,
        vendorTypes,
        referenceVendors,
        filters,
    ]);

    useEffect(() => {
        if (isFiltersProvided(filters)) {
            getVendorsNotOnVendorFiltersData();
        }
    }, [filters]);

    const getUniqueVendorIdsList = (detailMetricData) => {
        return [...new Set(detailMetricData.map(item => item.vendor_id))];
    };

    const addStatusesToMetricData = () => {
        const metricDataWithStatusesClone = _.cloneDeep(vendorsNotOnVendorList.results);
        metricDataWithStatusesClone.forEach((row) => {
            row.vendor_status = []
            vendorManagementStatuses.forEach(vendorStatus => {
                if(vendorStatus.vendor === row.vendor_id){
                    row.vendor_status.push(vendorStatus);
                }
            });
        });
        setMetricDataWithStatuses(metricDataWithStatusesClone);
    };

    useEffect(() => {
        if(vendorsNotOnVendorList?.results?.length && userDetails.accountFeatures.includes('diagnose_vendor_management')){
            getVendorManagementStatusesListData(getUniqueVendorIdsList(vendorsNotOnVendorList?.results));
        }
    }, [vendorsNotOnVendorList]);

    useEffect(() => {
        if(vendorManagementStatuses && vendorsNotOnVendorList?.results){
            addStatusesToMetricData();
        }

    }, [vendorManagementStatuses]);

    useEffect(() => {
        if(vendorManagementActivities?.length){
            getVendorManagementStatusesListData(getUniqueVendorIdsList(vendorsNotOnVendorList?.results));
        }
    }, [vendorManagementActivities]);

    const vendorsFilter = vendorsNotOnVendorFilter?.vendors?.map(filter => ({ text: filter, value: filter }));
    const technologiesFilter = vendorsNotOnVendorFilter?.technologies?.map(filter => ({ text: filter, value: filter }));
    const cookiesFilter = vendorsNotOnVendorFilter?.cookies?.map(filter => ({ text: filter, value: filter }));
    const referenceVendorsFilter = vendorsNotOnVendorFilter?.reference_vendors?.map(filter => ({ text: filter, value: filter }));

    const columns = [
        VendorTypeColumn({}),
        VendorNameColumn({ filters: vendorsFilter || [] }),
        VendorStatusColumn({ searchParams }),
        TechnologyCategorisationColumn({ filters: technologiesFilter || [] }),
        PrevalenceColumn,
        PrevalenceBenchMarkColumn,
        LastAppearedScanColumn,
        InformationStorageColumn,
        CookieNameColumn({ filters: cookiesFilter || [] }),
        VendorReferenceColumn({ filters: referenceVendorsFilter || [] }),
        VendorDetailsColumn({ metric: 'Non disclosed vendors observed' }),
    ];

    const onTableChange = (pagination, filters, sorter, extra) => {
        handleLimit(pagination.pageSize);
        handleOrder(sorter);

        for (const filter in filters) {
            if(filters[filter]){
                filter === 'technologies' && setTechnologies(filters[filter].join(';'));
                filter === 'reference_vendors' && setReferenceVendors(filters[filter].join(';'));
                filter === 'cookies' && setCookies(filters[filter].join(';'));
                filter === 'name' && setVendorNames(filters[filter].join(';'));
                filter === 'vendor_type' && setVendorTypes(filters[filter].join(';'));
                if (filter === 'information_storage') {
                    setUseFingerprint(null);
                    setUseLocalStorage(null);
                    setUseSessionCookies(null);
                    setUsePersistentCookies(null);
                    filters[filter].map( f => {
                        f === 'use_fingerprint' && setUseFingerprint(true);
                        f === 'use_local_storage' && setUseLocalStorage(true);
                        f === 'use_session_cookies' && setUseSessionCookies(true);
                        f === 'use_persistent_cookies' && setUsePersistentCookies(true);
                    });
                }
                filter === 'prevalence' && setPrevalenceRisk([filters[filter][0], filters[filter][1]]);
                filter === 'prevalence_benchmark' && setBenchRisk([filters[filter][0], filters[filter][1]]);
            } else {
                filter === 'technologies' && setTechnologies('');
                filter === 'reference_vendors' && setReferenceVendors('');
                filter === 'cookies' && setCookies('');
                filter === 'name' && setVendorNames('');
                filter === 'vendor_type' && setVendorTypes('');
                if (filter === 'information_storage') {
                    setUseFingerprint(null);
                    setUseLocalStorage(null);
                    setUseSessionCookies(null);
                    setUsePersistentCookies(null);
                }
                filter === 'prevalence_benchmark' && setBenchRisk([null, null]);
                filter === 'prevalence' && setPrevalenceRisk([null, null]);
            }
        }
    };

    const onPaginationChange = (pageNumber, pageSize) => {
        handlePageChange(pageNumber);
    };

    const exportCsv = () => {
        vendorsNotOnVendorExport(filters);
    };

    return (
        <div className={'detailed-breakdown-container'}>
            <div>The table below lists the vendors that we have observed on your properties
                that are not disclosed in your vendor list in the period of time selected.
                The information detailed should help you determine whether the vendor should
                be added to your vendor list or blocked.</div>
            <Divider />
            <div className='detailed-breakdown-table-container'>
                <div className={ 'filters_block' } >
                    <div className={ 'quick_filters' }>
                        {/*<div>Quick Filters:</div>*/}
                        {/*<Button >*/}
                        {/*    High risk vendors*/}
                        {/*</Button>*/}
                        {/*<Button >*/}
                        {/*    Medium risk vendors*/}
                        {/*</Button>*/}
                        {/*<Button >*/}
                        {/*   Low risk vendors*/}
                        {/*</Button>*/}
                    </div>
                    <div className={ 'downloadCSV' }>
                        <Button icon={<DownloadOutlined />} onClick={exportCsv} loading={vendorsNotOnVendorExportPending} />
                    </div>
                </div>
                <Table
                    id="detailed-breakdown"
                    getPopupContainer={trigger => document.getElementById('detailed-breakdown')}
                    scroll={{ x: 'max-content', y: 430 }}
                    dataSource={userDetails.accountFeatures.includes('diagnose_vendor_management') ? metricDataWithStatuses : vendorsNotOnVendorList?.results}
                    columns={userDetails.accountFeatures.includes('diagnose_vendor_management') ? columns : columns.filter(ea => ea.dataIndex !== "vendor_status") }
                    showSorterTooltip={false}
                    rowClassName={(record) => (record.vendor_id === searchParams?.vendor && searchParams?.type === 'NEW_VENDOR' ? 'diagnose-notification-highlight' : '')}
                    rowKey={(record) => record?.vendor_id + record.vendor_type + record.reference_vendors.length + record.technologies.length + record.cookies.length}
                    pagination={{ current: page, pageSize: limit, total: vendorsNotOnVendorList?.total_count, position: ['bottomCenter'], onChange: onPaginationChange, defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '50', '100', '200'] }}
                    onChange={onTableChange}
                    loading={{
                        className: 'diagnose-spinning',
                        spinning: vendorsNotOnVendorListPending || vendorManagementStatusesPending,
                        tip: vendorsNotOnVendorList?.results?.length ? '' : 'Processing a large query; please wait or leave it open and check later.',
                        size: 'large',
                    }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = function (store) {
    return {
        vendorsNotOnVendorList: store.diagnoseDashboardState.getIn(['vendorsNotOnVendorList', 'value']),
        vendorsNotOnVendorListPending: store.diagnoseDashboardState.get('vendorsNotOnVendorListPending'),
        vendorsNotOnVendorExportPending: store.diagnoseDashboardState.get('vendorsNotOnVendorExportPending'),
        vendorsNotOnVendorFilter: store.diagnoseDashboardState.getIn(['vendorsNotOnVendorFilter', 'value']),
        selectedFilters: store.diagnoseDashboardState.getIn(['selectedFilters', 'value']),
        vendorManagementStatuses: store.diagnoseDashboardState.getIn(['vendorManagementStatuses', 'value']),
        vendorManagementStatusesPending: store.diagnoseDashboardState.get('vendorManagementStatusesPending'),
        vendorManagementActivities: store.diagnoseDashboardState.getIn(['vendorManagementActivities', 'value']),
        userDetails: store.accountState.getIn(["userDetails", "value"]),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getVendorsNotOnVendorList,
        getVendorsNotOnVendorFilter,
        vendorsNotOnVendorExport,
        getVendorManagementStatusesList,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedBreakdown);
